import { jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { usePhonesListProvider } from "../../providers/phones-list-provider.js";
import { StyledMenu, StyledMenuItem } from "./PhonesList.styles.js";
import "react";
import "../../hooks/usePhones.js";
import "@tanstack/react-query";
import "../../helpers/common.js";
import "../../providers/axios-provider.js";
import "axios";
import "@mui/material/styles";
const PhonesList = ({ open, onClose, onSelect }) => {
  var _a;
  const { data } = usePhonesListProvider();
  const handleSelect = (phone) => (event) => onSelect(phone, event);
  return /* @__PURE__ */ jsx(
    StyledMenu,
    {
      id: "open-appointments-phones",
      keepMounted: true,
      open: !!open,
      anchorEl: open,
      onClose,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      children: (_a = data == null ? void 0 : data.content) == null ? void 0 : _a.map((phone) => /* @__PURE__ */ jsx(StyledMenuItem, { onClick: handleSelect(phone), children: /* @__PURE__ */ jsx(Typography, { variant: "Lato Body 1", children: phone.name }) }, phone.referenceId))
    }
  );
};
export {
  PhonesList
};
